import {
  Card,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Tooltip,
  Chip,
  IconButton,
  Grid,
  Divider,
} from "@mui/material";

import React, { useState } from "react";
import InfoIcon from "@mui/icons-material/Info";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import BlockIcon from "@mui/icons-material/Block";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import DescriptionIcon from "@mui/icons-material/Description";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import HistoryIcon from "@mui/icons-material/History";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import PendingActionsRoundedIcon from "@mui/icons-material/PendingActionsRounded";
import { show_proper_words } from "./Draft";
import StatusHistoryDialog from "../../components/dialogs/StatusHistoryDialog";
import FileManagement from "./FileManagement";
import AddAddonDialog from "../../components/dialogs/AddAddonDialog";
import UpdateAddonDialog from "../../components/dialogs/UpdateAddonDialog";
import { s3baseUri } from "../../config/config";
import AddIcon from "@mui/icons-material/Add";

let button_history_styles = {
  color: "#334155",
  border: "1px solid #e2e8f0",
  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
  "&:hover": {
    backgroundColor: "#f8fafc",
    borderColor: "#cbd5e1",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.08)",
  },
};
const AddonSummary = ({ addonList, formList, handleFetchDetail }) => {
  const navigate = useNavigate();

  const [openStatusDialog, setOpenStatusDialog] = useState(false);
  const [statusDialogMode, setStatusDialogMode] = useState("history"); // "history" or "reason"
  const [selectedAddon, setSelectedAddon] = useState(null);
  const [selectedNote, setSelectedNote] = useState(null);
  const [openBy, setOpenBy] = useState(false);
  const [showAddOnDialog, setShowAddOnDialog] = useState(false);
  const [showUpdateAddonDialog, setShowUpdateAddonDialog] = useState(false);

  const handleReasonDialogOpen = (record, isHistory = false) => {
    if (isHistory && record) {
      setSelectedNote(record);
      setOpenBy(true);
    } else {
      setSelectedNote(record);
      setSelectedAddon(record);
      setOpenBy(false);
    }
    setStatusDialogMode("reason");
    setOpenStatusDialog(true);
  };

  const handleHistoryDialogOpen = (addon) => {
    setSelectedAddon(addon);
    setStatusDialogMode("history");
    setOpenStatusDialog(true);
  };

  const handleStatusDialogClose = () => {
    setOpenStatusDialog(false);
    setSelectedNote(null);
    setOpenBy(false);
  };

  const handleEditAddon = (addon) => {
    setSelectedAddon(addon);
    setShowUpdateAddonDialog(true);
  };

  const handleContinue = (addon) => {
    if (!addon?.form || !Array.isArray(addon?.form)) {
      return;
    }

    const formList = addon?.form;

    for (let i = 0; i < formList.length; i++) {
      const section = formList[i];

      if (!section.is_completed) {
        if (section.has_sub_sections && section.sub_sections?.length > 0) {
          const incompleteSubSection = section.sub_sections.find(
            (sub) => !sub.is_completed
          );
          if (incompleteSubSection) {
            navigate(
              `/visa/addon/${addon._id}/${section.value}/${incompleteSubSection.value}`
            );
            return;
          }
        }
        navigate(`/visa/addon/${addon._id}/${section.value}`);
        return;
      }

      if (section.has_sub_sections && section.sub_sections?.length > 0) {
        const incompleteSubSection = section.sub_sections.find(
          (sub) => !sub.is_completed
        );
        if (incompleteSubSection) {
          navigate(
            `/visa/addon/${addon._id}/${section.value}/${incompleteSubSection.value}`
          );
          return;
        }
      }
    }

    const lastSection = formList[formList.length - 1];
    if (lastSection) {
      if (
        lastSection.has_sub_sections &&
        lastSection.sub_sections?.length > 0
      ) {
        const lastSubSection =
          lastSection.sub_sections[lastSection.sub_sections.length - 1];
        navigate(
          `/visa/addon/${addon._id}/${lastSection.value}/${lastSubSection.value}`
        );
      } else {
        navigate(`/visa/addon/${addon._id}/${lastSection.value}`);
      }
      return;
    }
  };

  if (
    (!addonList || addonList.length === 0) &&
    formList?.allowed_addon_limit <= 1
  ) {
    return null;
  }

  return (
    <>
      <div className="mt-4">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-3 gap-2">
          <h3 className="primary-color mb-0"> Add-on Application Summary</h3>

          {formList?.allowed_addon_limit > 1 && (
            <div className="d-flex align-items-center gap-3">
              <span
                style={{
                  minWidth: "100px",
                  whiteSpace: "nowrap",
                  flexShrink: 0,
                }}
              >
                Limit : {formList?.added_addon_count}/
                {formList?.allowed_addon_limit}
              </span>
              <Button
                variant="outlined"
                color="primary"
                startIcon={<AddIcon />}
                onClick={() => setShowAddOnDialog(true)}
                sx={{ minWidth: "110px", height: "29px", borderRadius: "6px" }}
                disabled={
                  formList?.added_addon_count >= formList?.allowed_addon_limit
                }
              >
                Add-on
              </Button>
            </div>
          )}
        </div>
        {addonList.map((addon, index) => (
          <div
            key={index}
            className="draft-card mb-4"
            style={{ display: "block" }}
          >
            <div style={{ paddingBottom: "4px", marginBottom: "4px" }}>
              <div className="d-flex flex-wrap w-100">
                <div className="w-100">
                  {addon?.investment_payment_status === "paid" ||
                  addon?.investment_payment_status ===
                    "processing" ? null : addon?.investment_payment_status ===
                    "unpaid" ? (
                    <div
                      className="payment-failed-msg"
                      style={{ marginBottom: "0" }}
                    >
                      Your previous payment was unsuccessful.
                    </div>
                  ) : addon?.initial_payment_status === "paid" &&
                    addon?.form_status === "approved" &&
                    addon?.investment_payment_status !==
                      "paid" ? null : addon?.form_status === "pending" ? (
                    <div
                      className="application-pending-msg"
                      style={{ marginBottom: "0" }}
                    >
                      Your add-on application has been submitted successfully
                      and is now under review. We’ll notify you via email as
                      soon as there is an update or if any further action is
                      required from your side.
                    </div>
                  ) : null}
                </div>
              </div>
            </div>

            <Grid container spacing={2} alignItems="center">
              {/* Column 1: Case Number & Status */}
              <Grid item md={4} sm={12} xs={12}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                  }}
                >
                  <div style={{ flexShrink: 0, minWidth: "120px" }}>
                    <p className="app-label mb-0">Case Number</p>
                    <Tooltip
                      title={`Name: ${addon?.addon_info?.first_name || ""} ${
                        addon?.addon_info?.last_name || ""
                      }`}
                    >
                      <p className="case-number">
                        {addon?.case_number || "N/A"}
                      </p>
                    </Tooltip>
                  </div>
                  <div className="custom-divider"></div>
                  <div style={{ flexGrow: 1 }}>
                    {addon?.form_status === "rejected" ? (
                      <div className="status-wrapper">
                        <div className="status-badge status-rejected">
                          <BlockIcon sx={{ fontSize: 18 }} />
                          Rejected
                        </div>
                        {addon?.note && (
                          <Tooltip title="View Rejection Reason" arrow>
                            <VisibilityIcon
                              sx={{
                                cursor: "pointer",
                                marginLeft: "8px",
                                fontSize: "18px",
                                color: "#15978a",
                              }}
                              onClick={() => handleReasonDialogOpen(addon)}
                            />
                          </Tooltip>
                        )}
                      </div>
                    ) : addon?.form_status === "info_required" ? (
                      <div className="status-wrapper">
                        <div className="status-badge status-info">
                          <InfoIcon sx={{ fontSize: 18 }} />
                          Info Required
                        </div>
                        {addon?.note && (
                          <Tooltip title="View Info Required Reason" arrow>
                            <VisibilityIcon
                              sx={{
                                cursor: "pointer",
                                marginLeft: "8px",
                                fontSize: "18px",
                                color: "#15978a",
                              }}
                              onClick={() => handleReasonDialogOpen(addon)}
                            />
                          </Tooltip>
                        )}
                      </div>
                    ) : addon?.investment_payment_status === "paid" ? (
                      <div className="status-badge status-paid">
                        <CheckCircleIcon sx={{ fontSize: 18 }} />
                        Investment Payment Paid
                      </div>
                    ) : addon?.investment_payment_status === "processing" ? (
                      <div className="status-badge status-processing">
                        <CheckCircleIcon sx={{ fontSize: 18 }} />
                        Payment In Processing
                      </div>
                    ) : addon?.form_status === "approved" ? (
                      <div className="status-badge status-approved">
                        <CheckCircleIcon sx={{ fontSize: 18 }} />
                        Approved
                      </div>
                    ) : addon?.form_status === "pending" ? (
                      <div className="status-badge status-review">
                        <HourglassEmptyIcon sx={{ fontSize: 18 }} />
                        In Review
                      </div>
                    ) : addon?.form_status === "fee_pending" ? (
                      <div className="status-badge status-review">
                        <HourglassEmptyIcon sx={{ fontSize: 18 }} />
                        Fee Pending
                      </div>
                    ) : addon?.form_status === "incomplete" ? (
                      <div className="status-badge status-processing">
                        <PendingActionsRoundedIcon sx={{ fontSize: 18 }} />
                        Incomplete
                      </div>
                    ) : (
                      <div className="footer-text" style={{ fontWeight: 800 }}>
                        {show_proper_words(addon?.form_status)}
                      </div>
                    )}
                  </div>
                </div>
              </Grid>

              <Divider
                orientation="vertical"
                flexItem
                sx={{
                  display: { md: "block", xs: "none" },
                  borderColor: "#e2e8f0",
                  height: "60px",
                  alignSelf: "center",
                }}
              />

              {/* Column 2: Dates */}
              <Grid item md={4} sm={12} xs={12}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    height: "100%",
                    gap: 0.5,
                  }}
                >
                  <div style={{ display: "flex", gap: "16px" }}>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div className="info-label">LAST UPDATED</div>
                      <div className="info-value">
                        {moment(addon?.updatedAt).format("MM-DD-YYYY")}
                      </div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div className="info-label">SUBMISSION DATE</div>
                      <div className="info-value">
                        {addon?.submitted_date
                          ? moment(addon?.submitted_date).format("MM-DD-YYYY")
                          : "N/A"}
                      </div>
                    </div>
                  </div>
                  {addon?.form_status === "fee_pending" && (
                    <div className="notice-box normal-notice mt-1">
                      <>
                        <span className="me-1 fw-600">Final Step:</span> Pay the
                        investment fee.
                      </>
                    </div>
                  )}
                </div>
              </Grid>

              <Divider
                orientation="vertical"
                flexItem
                sx={{
                  display: { md: "block", xs: "none" },
                  borderColor: "#e2e8f0",
                  height: "60px",
                  alignSelf: "center",
                }}
              />

              {/* Column 3: Actions */}
              <Grid
                item
                md={4}
                sm={12}
                xs={12}
                sx={{
                  display: "flex",
                  justifyContent: { md: "flex-end", xs: "flex-start" },
                  alignItems: "center",
                  mt: { md: 0, xs: 2 },
                  ml: "auto",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    width: "100%",
                  }}
                >
                  {addon?.form_status === "pending" ? (
                    <span className="notice-box review-notice">
                      Application is Under Review
                    </span>
                  ) : null}
                  {addon?.form_status === "rejected" ? (
                    <span className="notice-box rejected-notice">
                      Application is Rejected
                    </span>
                  ) : null}

                  {addon?.initial_payment_status !== "paid" && (
                    <div className="expire-notice">
                      <span>
                        Expires on:{" "}
                        <span className="fw-600">
                          {moment(addon?.updatedAt)
                            .add(30, "days")
                            .format("MM-DD-YYYY")}
                        </span>
                      </span>
                    </div>
                  )}

                  <div
                    style={{
                      marginLeft: "auto",
                      display: "flex",
                      gap: "8px",
                      alignItems: "center",
                    }}
                  >
                    {addon?.form_history?.length > 0 && (
                      <Button
                        sx={button_history_styles}
                        variant="outlined"
                        onClick={() => handleHistoryDialogOpen(addon)}
                        startIcon={<HistoryIcon />}
                      >
                        History
                      </Button>
                    )}
                  </div>

                  {addon?.form_status === "info_required" ? (
                    <Button
                      variant="contained"
                      onClick={() => handleContinue(addon)}
                      endIcon={<ArrowForwardIcon />}
                    >
                      Edit Your Form
                    </Button>
                  ) : addon?.investment_payment_status === "paid" ||
                    addon?.investment_payment_status ===
                      "processing" ? null : addon?.investment_payment_status ===
                    "unpaid" ? (
                    <Button
                      variant="contained"
                      onClick={() => navigate(`/payments/${addon._id}`)}
                      endIcon={<ArrowForwardIcon />}
                    >
                      Pay Investment Fee
                    </Button>
                  ) : addon?.initial_payment_status === "paid" &&
                    (addon?.form_status === "approved" ||
                      addon?.form_status === "fee_pending") &&
                    addon?.investment_payment_status !== "paid" ? (
                    <Button
                      variant="contained"
                      onClick={() => navigate(`/payments/${addon._id}`)}
                      endIcon={<ArrowForwardIcon />}
                    >
                      Pay Investment Fee
                    </Button>
                  ) : addon?.form_status === "pending" ||
                    addon?.form_status === "rejected" ||
                    addon?.form_status === "info_required" ||
                    addon?.initial_payment_status === "paid" ? null : (
                    <Button
                      variant="contained"
                      onClick={() => handleContinue(addon)}
                      endIcon={<ArrowForwardIcon />}
                    >
                      Continue
                    </Button>
                  )}

                  <FileManagement
                    form={addon}
                    isAddon={true}
                    mode="menu"
                    onEdit={
                      addon?.initial_payment_status !== "paid" ||
                      addon?.form_status === "info_required"
                        ? () => handleEditAddon(addon)
                        : null
                    }
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        ))}
      </div>

      {/* Reason Dialog */}
      <StatusHistoryDialog
        open={openStatusDialog}
        onClose={handleStatusDialogClose}
        mode={statusDialogMode}
        findData={selectedAddon}
        selectedNote={selectedNote}
        openBy={openBy}
        onBackToHistory={() => handleHistoryDialogOpen(selectedAddon)}
        onViewDetail={(row) => handleReasonDialogOpen(row, true)}
      />
      {/* Add Add-on Dialog */}
      <AddAddonDialog
        open={showAddOnDialog}
        onClose={() => setShowAddOnDialog(false)}
        handleFetchDetail={handleFetchDetail}
      />
      {/* Update Add-on Dialog */}
      <UpdateAddonDialog
        open={showUpdateAddonDialog}
        onClose={() => setShowUpdateAddonDialog(false)}
        getDetail={handleFetchDetail}
        initialData={selectedAddon?.addon_info}
        addon_id={selectedAddon?._id}
      />
    </>
  );
};

export default AddonSummary;
